import { Field, FormikProps } from 'formik';
import * as React from 'react';

import { AvailabilityFormData, TwsAdmin } from './types';
import TextArea from '../input-textarea';
import MaterialSelectInput from '../input-select';
import FormikTextInput from '../input-text';
import Tooltip from 'rc-tooltip';

interface OwnProps {
    choicesLoaded: boolean | null;
    choicesData: TwsAdmin.AvailabilityFormChoices | null;
    valuesLoaded: boolean | null;
    formikProps: FormikProps<AvailabilityFormData>;
}

export default class DayOfEventCard extends React.Component<OwnProps> {
    constructor(props: OwnProps) {
        super(props);
    }

    render() {
        const { choicesLoaded, choicesData, valuesLoaded, formikProps } = this.props;

        const dataFullyLoaded = choicesLoaded && !!choicesData && valuesLoaded;

        return (
            <div className='VenueManagement--card VenueManagement--dayofevent'>
                <div className='VenueManagement--card--header'>Day of event</div>
                <div className='VenueManagement--card--subheader'>
                    Set this venue's time and hour availability for the day of an event. Hover over a field for more explanation.
                </div>
                {((choicesLoaded && !choicesData) || valuesLoaded === false) && (
                    <div className='VenueManagement--card--body VenueManagement--form-level-error'>
                        Could not load form data, please try again later
                    </div>
                )}

                {dataFullyLoaded && (
                    <div className='VenueManagement--card--body'>
                        <div className='VenueManagement--row VenueManagement--dayofevent--top'>
                            <div className='VenueManagement--col'>
                                <Tooltip
                                    prefixCls='rc-tooltip__dark'
                                    placement='top'
                                    trigger={['hover']}
                                    mouseEnterDelay={1}
                                    overlay={<span>The earliest time setup can begin</span>}
                                >
                                    <span>
                                        <Field
                                            label='Event start time'
                                            component={MaterialSelectInput}
                                            name='availability_start_time'
                                            readonly={true}
                                            choices={!!choicesData ? this.choicesToArray(choicesData.availability_start_time) : []}
                                        />
                                    </span>
                                </Tooltip>
                                <div className='VenueManagement--row-divider' />
                                <Tooltip
                                    prefixCls='rc-tooltip__dark'
                                    placement='top'
                                    trigger={['hover']}
                                    mouseEnterDelay={1}
                                    overlay={<span>Should match the number of hours between event start and end times</span>}
                                >
                                    <span>
                                        <Field
                                            label='Maximum event hours'
                                            type='numbert'
                                            component={FormikTextInput}
                                            name='max_event_hours'
                                        />
                                    </span>
                                </Tooltip>
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col'>
                                <Tooltip
                                    prefixCls='rc-tooltip__dark'
                                    placement='top'
                                    trigger={['hover']}
                                    mouseEnterDelay={1}
                                    overlay={<span>Latest time event can be held until</span>}
                                >
                                    <span>
                                        <Field
                                            label='Event end time'
                                            component={MaterialSelectInput}
                                            name='availability_end_time'
                                            readonly={true}
                                            choices={!!choicesData ? this.choicesToArray(choicesData.availability_end_time) : []}
                                        />
                                    </span>
                                </Tooltip>
                                <div className='VenueManagement--row-divider' />
                                <Tooltip
                                    prefixCls='rc-tooltip__dark'
                                    placement='top'
                                    trigger={['hover']}
                                    mouseEnterDelay={1}
                                    overlay={<span>How extra hours (that go beyond allocated amount) will be charged</span>}
                                >
                                    <span>
                                        <Field
                                            label='Extra hours charge type'
                                            component={MaterialSelectInput}
                                            name='extra_hours_charge_type'
                                            readonly={true}
                                            choices={!!choicesData ? this.choicesToArray(choicesData.extra_hours_charge_type) : []}
                                        />
                                    </span>
                                </Tooltip>
                            </div>
                            <div className='VenueManagement--col-divider' />
                            <div className='VenueManagement--col'>
                                <Tooltip
                                    prefixCls='rc-tooltip__dark'
                                    placement='top'
                                    trigger={['hover']}
                                    mouseEnterDelay={1}
                                    overlay={<span>Number of hours included in package</span>}
                                >
                                    <span>
                                        <Field
                                            label='Allocated hours'
                                            component={FormikTextInput}
                                            name='allocated_hours'
                                            type='number'
                                            choices={!!choicesData ? this.choicesToArray(choicesData.availability_start_time) : []}
                                        />
                                    </span>
                                </Tooltip>
                                <div className='VenueManagement--row-divider' />
                                <Tooltip
                                    prefixCls='rc-tooltip__dark'
                                    placement='top'
                                    trigger={['hover']}
                                    mouseEnterDelay={1}
                                    overlay={<span>The amount that will be charged for extra hours (based on charge type)</span>}
                                >
                                    <span>
                                        <Field
                                            label='Extra hours charge fee'
                                            component={FormikTextInput}
                                            type='number'
                                            name='fees_per_extra_hour'
                                        />
                                    </span>
                                </Tooltip>
                            </div>
                        </div>
                        <div className='VenuemManagement--row VenueManagement--dayofevent--middle'>
                            <div className='VenuemManagement--col'>
                                <Field label='Availability description' component={TextArea} name='availability_description' />
                            </div>
                        </div>
                        <div className='VenueManagement--row VenueManagement--dayofevent--bottom'>
                            <div className='VenueManagement--col'>
                                <div className='VenueManagement--helptext'>
                                    Example description 1:
                                    <br />
                                    Flexible set up start time. Early morning can be arranged. Events must end by 2:00AM.
                                </div>
                            </div>
                            <div className='VenueManagement--visible-col-divider' />
                            <div className='VenueManagement--col'>
                                <div className='VenueManagement--helptext'>
                                    Example description 2:
                                    <br />
                                    Set up time can start at 4:00PM. Events must end by 1:00AM.
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }

    private choicesToArray<T>(data: TwsAdmin.BaseChoicesData<T>) {
        return data.choices.map((choice) => {
            return [choice.value, choice.label];
        });
    }
}
